<template>
  <div class="list-empty">
    <!-- 内容 -->
    <div :style="{'padding':emptyText?'40px 0':'118px 0'}" class="empty-content">
      <div class="empty-img"><img src="@/assets/images/common/xiaohe1.png"/></div>
      <p v-if="empType===1" class="empty-desc">没找到与"<span>{{ emptyText }}</span>"匹配内容，可以按月龄阶段或标签分类查查看噢～
      </p>
      <p v-if="empType===2" class="empty-desc">当前的条件暂无匹配内容，可以按月龄阶段或标签分类查查看噢～
      </p>
    </div>
  </div>
</template>

<style lang="less" scoped>
.list-empty {
  background: @expertFontColor255;

  .empty-content {
    width: 100%;
    height: 157px;
    margin: 0 auto;
    padding: 118px 0;

    .empty-img {
      width: 110px;
      height: 92px;
      margin: 0 auto;

      img {
        width: 100%;
        display: block;
      }
    }

    .empty-desc {
      width: 220px;
      margin: 16px auto 0;
      font-size: 14px;
      font-weight: 400;
      color: @expertFontColor51;
      line-height: 18px;
      text-align: center;

      span {
        color: #FF67C1;
      }
    }
  }
}
</style>

<script>
export default {
  props: {
    emptyText: String,
    empType: {
      type: Number,
      default: 1
    }
  },
  methods: {},

}
</script>